import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a1839c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sendMessage"
}
const _hoisted_2 = { class: "right-div" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "massage_info" }
const _hoisted_5 = {
  class: "check_img",
  src: "/assets/icon/check.png",
  srcset: "/assets/icon/check@2x.png 2x,/assets/icon/check@3x.png 3x"
}
const _hoisted_6 = {
  class: "check_img",
  src: "/assets/icon/double_check.png",
  srcset: "/assets/icon/double_check@2x.png 2x,/assets/icon/double_check@3x.png 3x"
}
const _hoisted_7 = { class: "time" }
const _hoisted_8 = {
  key: 1,
  class: "getMessage"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "massage_info" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "line_wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_line" }, null, -1))
const _hoisted_14 = { class: "line_text" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.messageType === 'seller')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: "message_style",
              innerHTML: $setup.message
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
              [_vShow, $setup.unreadStatus]
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
              [_vShow, !$setup.unreadStatus]
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$filters.getTime($setup.messageInfo.createdAt)), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "left-div",
            style: _normalizeStyle($setup.messageType == 'system'? {background: '#FFE071', color: 'black'} : '')
          }, [
            _createElementVNode("span", {
              class: "message_style",
              innerHTML: $setup.message
            }, null, 8, _hoisted_9)
          ], 4),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$filters.getTime($setup.messageInfo.createdAt)), 1)
          ])
        ])),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        ($setup.data === 'cancelToLeadAngel' || $setup.data === 'cancelToSeller')
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 협의 종료 "))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, " [제안 수정] ")),
        _createElementVNode("span", null, _toDisplayString($setup.date), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getTime($setup.messageInfo.createdAt)), 1)
      ])
    ], 512), [
      [_vShow, $setup.data === 'reSuggestToSeller' || $setup.data === 'reSuggestToLeadAngel' || $setup.data === 'cancelToLeadAngel' || $setup.data === 'cancelToSeller']
    ])
  ], 64))
}